<template>
  <div class="sf-pad-b-2">
    <div
      class="sf-level sf-pointer"
      :class="toggleGroupClass"
      data-testid="audit-log-group__toggle"
      @click="toggle"
    >
      <i class="fa sf-audit-log__group-icon" :class="auditGroupIcon"></i>

      <div class="sf-level sf-level-between">
        <div v-dompurify-html="message"></div>
      </div>
    </div>

    <div
      :class="auditGroupClass"
      class="sf-audit-log__group-item-wrapper"
      data-testid="audit-log-group__item"
    >
      <div
        v-for="audit in audits"
        :key="audit.id"
        class="sf-audit-log__group-item"
      >
        <audit-log-item v-bind="audit" />
      </div>
    </div>
  </div>
</template>

<script>
import AuditLogItem from './audit-log-item'

export default {
  components: {
    AuditLogItem,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    audits: {
      type: Array,
      required: true,
    },
    collapsedState: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      collapsed: this.collapsedState,
    }
  },
  computed: {
    auditGroupIcon() {
      return this.collapsed ? 'fa-angle-right' : 'fa-angle-down'
    },
    auditGroupClass() {
      return {
        'sf-hidden': this.collapsed,
      }
    },
    toggleGroupClass() {
      return {
        'sf-audit-log__group-header': !this.collapsed,
      }
    },
  },
  methods: {
    toggle() {
      this.collapsed = !this.collapsed
    },
  },
}
</script>
<style scoped lang="scss">
@import 'silverfin-ui-kit/src/scss/tooling';

.sf-audit-log {
  &__group-header {
    margin-bottom: 11px;
  }

  &__group-item {
    margin-left: 5px;
    padding-left: 10px;
    border-left: 1px solid -color('snow', 'darker');

    &:last-child > div {
      padding-bottom: 0 !important;
    }
  }

  &__group-icon {
    @include font-weight('bold');

    font-size: 16px;
    width: 10px;
    text-align: center;
    color: -color('gray');
    margin: 0 6px 0 0 !important;
  }
}
</style>
